export const STORES_DISCOUNT_CYC = { SELFIE: 30 }

export const STORES_REDIRECT_SHIPPING_STEP = []

export const LOCAL_PICKUP_DELIVERY_TIME = { 'Atakama Outdoor': 'Desde 50 minutos', Gotta: 'Desde 50 minutos' }

export const STORES_STOCKABLES = ['PinflagtestStore', 'Lippi', 'Haka Honu', 'Due Scarpe', 'Atakama Outdoor', 'Trailstore.cl', 'Me lo llevo', 'Simplit', 'Lhotse', 'Kano', 'Relan', 'Caracol Natural Skincare', 'Yambo Bags', 'Raindoor', 'RI soluciones', 'Gotta']

export const STORES_DEFAULT_WEIGHT = {
  'Safety Store B2B': 20
}

export const STORES_WITH_CLICK_AND_COLLECT_DISCOUNT = ['Lippi', 'Haka Honu', 'Brando']

export const STORES_WITH_THIRD_PARTY_RATES = ['Atakama Outdoor', 'Zazu', 'Veus', 'Caracol Natural Skincare', 'Me lo llevo', 'Lhotse', 'Simplit', 'Kano', 'Relan', 'Yambo Bags', 'Verde Legion', 'Monarch', 'Zitica', 'Gotta', 'Raindoor', 'Head Chile']

export const THIRD_PARTY_RATES_DATA = {
  'Atakama Outdoor': {
    'Retiro en tienda Nomad': {
      description: 'Retira en 50 minutos',
      packageDeliveryTime: '50 minutos'
    },
    'Nomad - Envío Express': {
      description: '',
      packageDeliveryTime: ''
    }
  },
  Veus: {
    'Envío Express': {
      description: 'Despacho en 3 horas (días hábiles)',
      packageDeliveryTime: '3 horas (días hábiles)'
    }
  },
  'Me lo llevo': {
    'Bluexpress Sameday': {
      description: 'Por compras realizadas antes de las 10.59 de Lunes a Viernes, solo RM',
      packageDeliveryTime: ''
    },
    'Bluexpress Priority': {
      description: 'Por compras antes de las 10.59, llega al día siguiente (de Lunes a Viernes)',
      packageDeliveryTime: ''
    }
  },
  Lhotse: {
    'Bluexpress Sameday': {
      description: 'Por compras realizadas antes de las 10.59 de Lunes a Viernes, solo RM',
      packageDeliveryTime: ''
    },
    'Bluexpress Priority': {
      description: 'Por compras antes de las 10.59, llega al día siguiente (de Lunes a Viernes)',
      packageDeliveryTime: ''
    }
  },
  Simplit: {
    'Bluexpress Sameday': {
      description: 'Por compras realizadas antes de las 10.59 de Lunes a Viernes, solo RM',
      packageDeliveryTime: ''
    },
    'Bluexpress Priority': {
      description: 'Por compras antes de las 10.59, llega al día siguiente (de Lunes a Viernes)',
      packageDeliveryTime: ''
    }
  },
  'Verde Legion': {
    'Despacho gratis': {
      description: 'Se despacha los días jueves',
      packageDeliveryTime: ''
    },
    'Despacho a domicilio': {
      description: '1 a 2 días hábiles',
      packageDeliveryTime: ''
    },
    'Despacho Escar': {
      description: 'Se despacha todos los días',
      packageDeliveryTime: ''
    },
    'Despacho Esucar': {
      description: 'Se despacha los días jueves',
      packageDeliveryTime: ''
    },
    'Despacho Esfocar': {
      description: 'Se despacha los días jueves',
      packageDeliveryTime: ''
    }
  }
}

export const BILLING_TYPE_STORES = {
  'Atakama Outdoor': 'attributes[billing_documento]=33&',
  Ironside: 'attributes[tipo_documento]=FACTURA&',
  Pronobel: 'attributes[tipoDocumento]=Factura&',
  Tost: 'attributes[Tipo de documento]=factura&',
  Heimat: 'attributes[shoppingcart-tags]=factura&',
  Kendal: 'attributes[shoppingcart-tags]=factura&',
  Scaldasonno: 'attributes[shoppingcart-tags]=factura&'
}

export const SHOPIFY_PLUS_STORES = ['Ironside', 'Pichara', 'Test Store', 'Monarch']

export const ONLY_CHECKOUT = [
  'Opaline',
  'Colloky'
]

export const DIFFERENT_REGION_NAME = [
  'Opaline',
  'Colloky'
]

export const CHANGE_ORDER = [
  'Lorenzo di Pontti'
]

// Stores that will not use Pinflag services
export const STORES_WITHOUT_PINFLAG_SERVICES = ['Me lo llevo', 'Lhotse', 'Simplit', 'Kano', 'Relan', 'Yambo Bags', 'Verde Legion', 'Monarch', 'Zitica', 'Head Chile']

// Stores that will use Pinflag services only for these states
export const SPECIFIC_STATES_PINFLAG_SERVICES = {
  Raindoor: [13]
}

export const STORES_WITH_DEFAULT_DOCUMENT = ['Atakama Outdoor', 'Vielco', 'Pronobel', 'Tost', 'Heimat', 'Kendal', 'Scaldasonno']

export const STORES_WITH_ACCOUNT_LINK = {
  SELFIE: 'https://www.selfie.cl/account/login?return_url=%2Faccount',
  Epic: 'https://epic.cl/ingresar/'
}

export const CUSTOM_BILLING_BUTTON_COLOR = {
  'HARD WORK': 'bg-[#F7931E]',
  'STEEL PRO SAFETY': 'bg-[#F7931E]',
  TECNOBOGA: 'bg-[#F7931E]',
  EDELBROCK: 'bg-[#F7931E]',
  'BEST SHOES': 'bg-[#F7931E]',
  Vicsa: 'bg-[#F7931E]',
  'Safety Store B2B': 'bg-[#F7931E]',
  'SAFETY OUTLET': 'bg-[#F7931E]',
  'SAFETY STORE': 'bg-[#F7931E]',
  'Vitel Energia': 'bg-[#33C028]',
  Pronobel: 'bg-[#6C88E1]',
  Tost: 'bg-[#FF5C35]'
}

export const CUSTOM_BILLING_BUTTON_TEXT = {
  Tost: '¿Necesitas factura?'
}

// Hide a pickup point if another related point is available
// Example: If the store with CMS ID gid://shopify/Location/74951786731 has stock,
// the point named "Showroom Atakama Outdoor" should not be shown
// Else, the point with CMS ID gid://shopify/Location/74951786731 should not be shown
export const HIDE_PICKUP_POINT_MAPPING = {
  'Atakama Outdoor': {
    'gid://shopify/Location/74951786731': 'Showroom Atakama Outdoor'
  },
  Gotta: {
    'gid://shopify/Location/75313447083': 'Gotta Calle Estado 291',
    'gid://shopify/Location/74378248363': 'Gotta Manquehue',
    'gid://shopify/Location/77416595627': 'Espacio Urbano 15 Norte',
    'gid://shopify/Location/77416726699': 'Mall del Centro Concepción',
    'gid://shopify/Location/78206402731': 'Mall Arauco Maipú'
  }
}

export const COMPANIES_URL = {
  'Tost Express': {
    url: 'https://tost.cl',
    urlText: 'Tost.cl'
  }
}
